import { render } from "./BrandPixsell.vue?vue&type=template&id=26d55920"
import script from "./BrandPixsell.vue?vue&type=script&lang=ts"
export * from "./BrandPixsell.vue?vue&type=script&lang=ts"

import "./BrandPixsell.vue?vue&type=style&index=0&id=26d55920&lang=scss"
script.render = render

export default script